import React, { useEffect, createElement } from 'react';
interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
  canonical?: string;
}
export function useSEO({
  title,
  description,
  keywords,
  ogImage,
  ogType = 'website',
  canonical
}: SEOProps) {
  useEffect(() => {
    // Update document title
    document.title = `${title} | ARIH Agadir Souss Massa`;
    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    // Basic meta tags
    updateMetaTag('description', description);
    if (keywords) {
      updateMetaTag('keywords', keywords);
    }
    // Open Graph tags
    updateMetaTag('og:title', `${title} | ARIH Agadir Souss Massa`, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:type', ogType, true);
    updateMetaTag('og:url', window.location.href, true);
    if (ogImage) {
      updateMetaTag('og:image', ogImage, true);
    }
    // Twitter Card tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', `${title} | ARIH Agadir Souss Massa`);
    updateMetaTag('twitter:description', description);
    if (ogImage) {
      updateMetaTag('twitter:image', ogImage);
    }
    // Canonical URL
    let linkElement = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!linkElement) {
      linkElement = document.createElement('link');
      linkElement.setAttribute('rel', 'canonical');
      document.head.appendChild(linkElement);
    }
    linkElement.setAttribute('href', canonical || window.location.href);
    // HTML lang attribute
    document.documentElement.setAttribute('lang', 'fr');
  }, [title, description, keywords, ogImage, ogType, canonical]);
}
export function SEO(props: SEOProps) {
  useSEO(props);
  return null;
}